/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="../../baseClasses/dataservicebase.ts" />
/// <reference path="../../filters/invOnHand.ts" />

module Meevo.Components.Controls {
    "use strict";
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import ProductPackageTypeEnum = Meevo.Model.ProductPackageTypeEnum;

    export class ProductVariant implements angular.IDirective {
        static $inject = ["$timeout", "$translate"];
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected identityService: Meevo.Components.Common.IIdentityService;

        constructor(private $timeout: ng.ITimeoutService, public $translate: angular.translate.ITranslateService){
        }

        dataService: Meevo.Components.BaseClasses.DataServiceBase;
        restrict = "E";
        scope = {
            context: "=context",
            maxvariants: "=?maxvariants",
            disablevariantconsolidation: "=?disablevariantconsolidation",
            tabIndex: "=?",
            tenantEnableProductUsageTracking: "=?",
            decimalPrecision: "=?",
            inventoryNegativeTracking: "=?"
        };

        templateUrl = "app/components/controls/product/productVariantTemplate.html";

        controller = ['$scope', (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            scope.activeVariants = [];
            scope.isVariantAttributeFromDB = [];
            scope.isCOLocation = false;
            scope.isMarketPricingEnabled = false;
            scope.removable = false;
            scope.allowDeleteChip = {};
            scope.productInventoryTypeEnum = ProductInventoryTypeEnum;
            scope.enableVariantConsolidation = false;
            scope.hideRemainingVariants = false;
            scope.originalVariantsCopy = [];
            scope.originalVariantAttributesLength = 0;
            scope.originalVariantAtributes = [];
            scope.originalhasVariants = null;
            scope.latestConsolidatedVariantsCopy = null;
            scope.renamingChip = false;
            scope.chipBeingRenamed = null;
            scope.chipRowBeingRenamed = null;
            scope.variantAttributePlaceholder = this.$translate.instant("LABEL_ENTER_VALUES_FOR_ATTRIBUTE");
            scope.deletedVariantCombinations = [];
            scope.hasVariantToConsolidate = false;

            scope.tenantEnableProductUsageTracking = scope.tenantEnableProductUsageTracking || false;
            scope.decimalPrecision = scope.decimalPrecision || 4;

            scope.hasMissingVariants = false;
            var attributesToVariant: any = {};
            var numOfVariantsWithMissingAttributes: number = 0;

            scope.focusChipEditor = (event) => {
                document.getElementById("chipEditor").focus();
                event.stopPropagation();
            }

            scope.isChipBeingRenamed = (row: any): boolean => {
                return (scope.renamingChip
                    && scope.chipBeingRenamed != null
                    && scope.chipRowBeingRenamed != null
                    && row.variantType == scope.chipRowBeingRenamed.variantType);
            }

            scope.variantAttributePlaceholderLabel = (row: any): string => {
                if (scope.isChipBeingRenamed(row)) {
                    return this.$translate.instant("LABEL_RENAME_ATTRIBUTE") + scope.chipBeingRenamed;
                }
                else {
                    return this.$translate.instant("LABEL_ENTER_VALUES_FOR_ATTRIBUTE");
                }
            }

            // Add a max character length to md-chips template text input
            scope.limitAttributeCharLength = () => {
                //setTimeout(function () {
                //    angular.element(angular.element("md-chips-wrap > div > div > input")).attr("maxlength", "8");
                //},500);
                $(".md-select-menu-container").hide();
            };

            //TODO: New Guid -> Sequential Guid
            scope.pushVariant = (name?: string) => {

                const variantId = Guid.newSqlSequentialGuid().toString();

                const initialStock1: Meevo.Model.VariantStockLevel = {
                    variantId: variantId,
                    productPackageType: ProductPackageTypeEnum.Each,
                    productInventoryType: ProductInventoryTypeEnum.Retail,
                    multiplesOf: 1,
                    modelQuantity: 0,
                    orderPoint: 0,
                    onHand: 0,
                    wasChanged: false,
                    isDisplayed: true
                };

                const initialStock2: Meevo.Model.VariantStockLevel = {
                    variantId: variantId,
                    productPackageType: ProductPackageTypeEnum.Each,
                    productInventoryType: ProductInventoryTypeEnum.ShopSupply,
                    multiplesOf: 1,
                    modelQuantity: 0,
                    orderPoint: 0,
                    onHand: 0,
                    wasChanged: false,
                    isDisplayed: false
                }

                const variant: Meevo.Model.ProductVariant = {
                    displayName: name,
                    id: variantId,
                    objectState: Meevo.Model.ObjectStateEnum.Active,
                    markUp: 0,
                    wholeSale: 0,
                    retail: 0,
                    notForSale: false,
                    excludePointPromotion: false,
                    sortOrder: scope.context.selectedSection.model.variants.length,
                    productInventoryType: ProductInventoryTypeEnum.Retail,
                    isInventoryTrackable: 1,
                    trackLots: false,
                    trackExpirationDate: true, // 132418: Track Expiration defaults ON for new variants (editable until lots exist)
                    hasLots: false,
                    floorLocation: "",
                    floorLocations: [],
                    noOfWeeksValid: 0,
                    variantDistributorIds: [],
                    variantStockLevels: [initialStock1, initialStock2],
                    previousInformation: "",
                    alreadyConsolidated: false,
                    variantAttributes: []
                }

                scope.context.selectedSection.model.variants.push(variant);

            }

            scope.InitializeData = () => {                
                scope.isCOLocation = (scope.context.identityService.inCentralOfficeMode()
                    && scope.context.identityService.checkCentralOfficeLocationId(scope.context.asLocationId)
                    && scope.context.identityService.checkCentralOfficeLocationId(scope.context.selectedSection.model.homeLocationId))
                    || scope.context.identityService.isSingleLocation();

                // get attribute list from the system enums
                scope.context.dataService.getEnumList(Meevo.Model.EnumTypeEnum.VariantTypeEnum).then((data) => {
                    scope.variantTypes = data;
                });
                scope.context.dataService.getEnumList(Meevo.Model.EnumTypeEnum.ProductInventoryTypeEnum)
                    .then((response: any) => {
                        scope.productInventoryTypes = _.filter(response, function (itype) {
                            return itype["id"] != ProductInventoryTypeEnum.Other;
                        });
                    });

                // Hide the hard coded md-chips template delete button
                setTimeout(function () {
                    angular.element(angular.element("md-chips-wrap > md-chip > div > button")).attr("style", "visibility: hidden");
                }, 150);

                if (scope.context.selectedSection.model == null) {
                    scope.context.selectedSection.model = {};
                }

                if (scope.context.selectedSection.model.variants == null) {
                    scope.context.selectedSection.model.variants = [];
                }

                if (scope.context.selectedSection.model.productVariantAttributes == null) {
                    scope.context.selectedSection.model.productVariantAttributes = [
                        {
                            id: Guid.newSqlSequentialGuid().toString(),
                            index: 0,
                            displayName: [],
                            variantType: null,
                            sortOrder: 0
                        }
                    ];
                }

                var numAttributes = scope.originalVariantAttributesLength = scope.context.selectedSection.model.productVariantAttributes.length;
                var attributeHasValueFromDB = (numAttributes >= 1 && scope.context.selectedSection.model.productVariantAttributes[0].displayName.length >= 1);

                // setup attribute matrix
                if (attributeHasValueFromDB) {
                    scope.context.selectedSection.model.productVariantAttributes[0].displayName.forEach((name, ndx, arr) => attributesToVariant[name] = (numAttributes > 1 ? {} : null));

                    // assign variant into matrix
                    for (var i = 0, n = scope.context.selectedSection.model.variants.length; i < n; i++) {
                        var thisVariant = scope.context.selectedSection.model.variants[i];
                        if (!createMatrixEntry(thisVariant)) {
                            // no attributes found, create them here
                            assignEmptyAttribute(thisVariant, numOfVariantsWithMissingAttributes);
                            numOfVariantsWithMissingAttributes++;
                            createMatrixEntry(thisVariant);
                        }
                    }
                }

                // An existing (persisted) product must be treated as multi-variant whenever it has
                // DB-backed attributes, regardless of edit/readonly mode. showEdit/showUndelete are
                // only true in readonly mode, so without this an existing product re-initialized while
                // in edit mode (the section is torn down and rebuilt whenever loadingInProgress toggles,
                // e.g. after a failed save) falls through to the "new product" branch below, which wipes
                // the loaded variants and seeds a blank one. See ADO 130208 follow-up.
                var isExistingProduct = scope.context.itemId && scope.context.itemId !== Guid.empty;

                // these if statements determine how to load the page because we do not have a property that tells us wether or not we have multiple variants
                if (attributeHasValueFromDB
                    && scope.context.selectedSection.model.variants.length >= 1
                    && scope.context.selectedSection.model.displayName
                    && (scope.context.showEdit || scope.context.showUndelete || isExistingProduct)) {

                    scope.hasVariantToConsolidate = true;
                    scope.hasVariants = Meevo.Model.ObjectStateEnum.Active;
                    scope.originalhasVariants = angular.copy(scope.hasVariants);

                    for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                        var thisVariant = scope.context.selectedSection.model.variants[i];

                        thisVariant.fromDB = true;
                        thisVariant.isSkuValid = true;
                        thisVariant.isBarCodeValid = true;

                        setMarkUpValue(thisVariant);

                        if (scope.context.selectedSection.model.distributors != null && scope.context.selectedSection.model.distributors.length > 0) {

                            var distributorIds = _.clone(thisVariant.variantDistributorIds)
                            for (var d = 0; d < scope.context.selectedSection.model.distributors.length; d++) {
                                thisVariant.variantDistributorIds[d] = _.find(distributorIds, function (dId) { return dId['distributorId'] == scope.context.selectedSection.model.distributors[d].id });
                            }
                        }

                        scope.setDefaultStockLevelInformation(thisVariant);
                        scope.determineWhichStockLevelRecordsToDisplay(thisVariant);
                        scope.determineIfRevertIndicatorIsShown(thisVariant);
                    }

                    for (var i = 0; i < scope.context.selectedSection.model.productVariantAttributes.length; i++) {
                        scope.context.selectedSection.model.productVariantAttributes[i].fromDB = true;
                        if (scope.allowDeleteChip[i] == null) {
                            scope.allowDeleteChip[i] = [];
                        }
                        for (var j = 0; j < scope.context.selectedSection.model.productVariantAttributes[i].displayName.length; j++) {
                            scope.allowDeleteChip[i][scope.context.selectedSection.model.productVariantAttributes[i].displayName[j]] = false;
                        }
                    }

                    if (scope.context.selectedSection.model.variants.length < getTotalCombination()) {
                        scope.createAllVariantCombinations(true);
                    }
                }
                else if (scope.context.selectedSection.model.variants.length == 1
                    && scope.context.selectedSection.model.variants[0].displayName == "default") {

                    scope.hasVariantToConsolidate = true;
                    scope.hasVariants = Meevo.Model.ObjectStateEnum.Inactive;
                    scope.originalhasVariants = angular.copy(scope.hasVariants);

                    var thisVariant = scope.context.selectedSection.model.variants[0];

                    thisVariant.fromDB = true;
                    thisVariant.isSkuValid = true;
                    thisVariant.isBarCodeValid = true;

                    setMarkUpValue(thisVariant);

                    if (scope.context.selectedSection.model.distributors != null && scope.context.selectedSection.model.distributors.length > 0) {

                        var distributorIds = _.clone(thisVariant.variantDistributorIds)
                        for (var d = 0; d < scope.context.selectedSection.model.distributors.length; d++) {
                            thisVariant.variantDistributorIds[d] = _.find(distributorIds, function (dId) { return dId['distributorId'] == scope.context.selectedSection.model.distributors[d].id });
                        }
                    }
                    scope.setDefaultStockLevelInformation(thisVariant);
                    scope.determineWhichStockLevelRecordsToDisplay(thisVariant);
                    scope.determineIfRevertIndicatorIsShown(thisVariant);
                }
                else {
                    // Call the variant push 
                    if (!scope.context.showEdit || (scope.context.selectedSection.model.variants != null && scope.context.selectedSection.model.variants.length == 0)) { // this if statement makes sure that we are adding a new Product
                        scope.hasVariantToConsolidate = false;
                        scope.hasVariants = Meevo.Model.ObjectStateEnum.Inactive;
                        scope.originalhasVariants = _.clone(scope.hasVariants);
                        scope.context.selectedSection.model.variants = [];
                        scope.pushVariant(scope.currentVariantName);
                        scope.amIDiscountinued(scope.context.selectedSection.model.variants[0]);
                        scope.setDefaultStockLevelInformation(scope.context.selectedSection.model.variants[0]);
                        scope.determineWhichStockLevelRecordsToDisplay(scope.context.selectedSection.model.variants[0]);
                        scope.determineIfRevertIndicatorIsShown(scope.context.selectedSection.model.variants[0]);
                    }
                }
            }

            function getTotalCombination(): number {
                var totalCombination: number = 0;
                var numAttributes = scope.context.selectedSection.model.productVariantAttributes.length;
                if (numAttributes > 0) {
                    totalCombination = scope.context.selectedSection.model.productVariantAttributes[0].displayName.length;

                    if (numAttributes > 1) {
                        totalCombination = totalCombination * scope.context.selectedSection.model.productVariantAttributes[1].displayName.length;
                    }

                    if (numAttributes > 2) {
                        totalCombination = totalCombination * scope.context.selectedSection.model.productVariantAttributes[2].displayName.length;
                    }

                    scope.hasMissingVariants = (totalCombination > scope.context.selectedSection.model.variants.length);
                }
                return totalCombination;
            }

            function createMatrixEntry(thisVariant: any, attribIndex: number = 0, obj: any = attributesToVariant): boolean {
                if (thisVariant.variantAttributes.length > attribIndex) {
                    var attrDisplayName = thisVariant.variantAttributes[attribIndex].displayName[0];
                    if (!obj[attrDisplayName]) {
                        obj[attrDisplayName] = {};
                    }
                    if (thisVariant.variantAttributes.length - 1 > attribIndex) {
                        return createMatrixEntry(thisVariant, ++attribIndex, obj[attrDisplayName]);
                    }
                    else {
                        obj[attrDisplayName] = thisVariant;
                        return true;
                    }
                }
                return false;
            }

            function setMarkUpValue(variant) {
                if (variant.wholeSale > 0 && (variant.retail / variant.wholeSale) - 1 > 0)
                    variant.markUp = ((variant.retail / variant.wholeSale) - 1).toFixed(4);
                else
                    variant.markUp = 0.0;
            }

            function assignEmptyAttribute(thisVariant: any, ndx: number) {
                var variantAttrs = thisVariant.variantAttributes;
                // [none]
                for (var i = 0; i < scope.context.selectedSection.model.productVariantAttributes.length; i++) {
                    let productVariantAttribute: Meevo.Model.ProductVariantAttribute = scope.context.selectedSection.model.productVariantAttributes[i];
                    let newVariantAttrDisplayName = ndx == 0 ? "[none]" : `[none${ndx}]`;
                    let newVariantAttrSortOrder = productVariantAttribute.displayName.push(newVariantAttrDisplayName);
                    variantAttrs.push(
                        {
                            "variantType": productVariantAttribute.variantType,
                            "sortOrder": (i * 1000) + newVariantAttrSortOrder,
                            "displayName": [newVariantAttrDisplayName],
                            "id": new Guid(thisVariant.id)
                        }
                    );
                }
                // update variant's displayName based on new attributes
                thisVariant.displayName = _.map(variantAttrs, (va: Model.ProductVariantAttribute) => { return va.displayName[0]; }).join(" ");
            }

            scope.isMissingVariant = (chipName) => {
                return scope.hasVariantToConsolidate && chipName.indexOf('[none') > -1;
            }
            scope.isMarketPricingEnabled = () => {                
                return scope.context.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MARKETPRICING + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
            }
            scope.isApplicationModeCO = () => {
                return this.identityService.inCentralOfficeMode();
            }
            scope.setDefaultStockLevelInformation = (variant) => {
                if (variant.variantStockLevels == null || (variant.variantStockLevels != null && variant.variantStockLevels.length == 0) || (variant.variantStockLevels != null && variant.variantStockLevels.length == 1 && variant.variantStockLevels[0].productInventoryType == 0)) {
                    variant.variantStockLevels = [
                        {
                            variantId: variant.id,
                            productPackageType: ProductPackageTypeEnum.Each,
                            productInventoryType: ProductInventoryTypeEnum.Retail,
                            multiplesOf: 1,
                            modelQuantity: 0,
                            orderPoint: 0,
                            onHand: 0,
                        },
                        {
                            variantId: variant.id,
                            productPackageType: ProductPackageTypeEnum.Each,
                            productInventoryType: ProductInventoryTypeEnum.ShopSupply,
                            multiplesOf: 1,
                            modelQuantity: 0,
                            orderPoint: 0,
                            onHand: 0,
                        }
                    ]
                }
                else {
                    for (var i = 0; i < variant.variantStockLevels.length; i++) {

                        if (variant.variantStockLevels[i].nullProductPackageTypeAndMultiplesOfValuesBeforeSaving) {
                            variant.variantStockLevels[i].productPackageType = (variant.variantStockLevels[i].productPackageType_T == null) ? 2365 : variant.variantStockLevels[i].productPackageType_T;
                            variant.variantStockLevels[i].multiplesOf = (variant.variantStockLevels[i].multiplesOf_T == null) ? 1 : variant.variantStockLevels[i].multiplesOf_T;
                        }

                        variant.variantStockLevels[i].nullModelQuantityAndOrderPointValuesBeforeSaving = (variant.variantStockLevels[i].modelQuantity == null && variant.variantStockLevels[i].orderPoint == null);
                        if (variant.variantStockLevels[i].nullModelQuantityAndOrderPointValuesBeforeSaving) {
                            variant.variantStockLevels[i].modelQuantity = (variant.variantStockLevels[i].modelQuantity_T == null) ? 0 : variant.variantStockLevels[i].modelQuantity_T;
                            variant.variantStockLevels[i].orderPoint = (variant.variantStockLevels[i].orderPoint_T == null) ? 0 : variant.variantStockLevels[i].orderPoint_T;
                        }

                        if (variant.variantStockLevels[i].productPackageType == null || variant.variantStockLevels[i].productPackageType == 0) {
                            variant.variantStockLevels[i].productPackageType = ProductPackageTypeEnum.Each;
                        }

                        if (variant.variantStockLevels[i].multiplesOf == null) {
                            variant.variantStockLevels[i].multiplesOf = 1;
                        }

                        if (variant.variantStockLevels[i].modelQuantity == null) {
                            variant.variantStockLevels[i].modelQuantity = 0;
                        }

                        if (variant.variantStockLevels[i].orderPoint == null) {
                            variant.variantStockLevels[i].orderPoint = 0;
                        }

                        if (variant.variantStockLevels[i].onHand == null) {
                            variant.variantStockLevels[i].onHand = 0;
                        }
                    }
                }
            }

            scope.editChipOrStopEditing = (row: any, chip: string) => {
                // Don't allow renaming chip during consolidation or not in edit mode or if product belongs to 
                if (scope.context.showEdit || scope.enableVariantConsolidation || scope.context.selectedSection.model.homeLocationId != scope.context.selectedSection.model.locationId) {
                    return;
                }

                //Exit Chip Editing Mode
                if (row == scope.chipRowBeingRenamed && chip == scope.chipBeingRenamed && scope.renamingChip) {
                    scope.renamingChip = false;
                    scope.chipBeingRenamed = null;
                    scope.chipRowBeingRenamed = null;
                    row.newChipName = "";
                }
                // Enter Chip Editing Mode
                else if (row != null && chip != null) {
                    //row.style = "focused";
                    scope.chipRowBeingRenamed = row;
                    scope.chipBeingRenamed = chip;
                    row.newChipName = chip;
                    scope.renamingChip = true;
                }
            }

            scope.renameAllVariantChipMatches = (rowIndex, chip: any, newName: string) => {
                if (scope.context.selectedSection.model.productVariantAttributes != null && scope.context.selectedSection.model.productVariantAttributes[rowIndex] != null) {
                    // Change existing variant attribute type name
                    for (var j = 0; j < scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName.length; j++) {
                        if (scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName[j] == scope.chipBeingRenamed) {
                            scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName[j] = newName;
                            break;
                        }
                    }

                    // Change existing Variant Names
                    for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                        const variant = scope.context.selectedSection.model.variants[i];
                        for (var j = 0; j < variant.variantAttributes.length; j++) {
                            const attribute = variant.variantAttributes[j];
                            if (attribute.variantType == scope.context.selectedSection.model.productVariantAttributes[rowIndex].variantType) {
                                for (var k = 0; k < attribute.displayName.length; k++) {
                                    if (attribute.displayName[k] == scope.chipBeingRenamed) {
                                        attribute.displayName[k] = newName;
                                        break;
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
            }

            scope.chipKeypress = (rowIndex, chip: any, row, event) => {
                if (event.keyCode == 13) {
                    scope.changeAttributeName(rowIndex, chip, row);
                }
                event.stopPropagation();
            }

            scope.changeAttributeName = (rowIndex, chip: any, row) => {
                if (scope.renamingChip) {
                    var rowDisplayNames = scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName;

                    // check if chip name already exists
                    for (var i = 0; i < rowDisplayNames.length; i++) {
                        if (rowDisplayNames[i] == row.newChipName) {
                            var selectedVariantType = _.find(scope.variantTypes, function (variantType) { return variantType["id"] == row.variantType; });
                            var selectedAttribute = selectedVariantType["displayName"];
                            let message = scope.context.$translate.instant("MESSAGE_ATTRIBUTE_DISPLAYNAME_ALREADY_EXIST", {
                                attribute: selectedAttribute,
                                displayname: row.newChipName
                            });
                            scope.context.modalService.alert(message);
                            return;
                        }
                    }

                    if (scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName != null && row.newChipName != null && row.newChipName != "") {
                        scope.allowDeleteChip[rowIndex][row.newChipName] = false;
                        scope.renameAllVariantChipMatches(rowIndex, chip, row.newChipName);
                        scope.processVariantNames();
                    }
                    scope.renamingChip = false;
                    scope.chipRowBeingRenamed = null;
                    scope.chipBeingRenamed = null;
                }
            }

            scope.sortVariantsBySku = () => {
                scope.context.selectedSection.model.variants.sort(function (a, b) { return sortAlphaNum(a.sku, b.sku) });
            }

            // Add Variant combination data and re-process possible Variant combinations
            scope.addVariant = (rowIndex: number, chip: any) => {

                const pva = scope.context.selectedSection.model.productVariantAttributes;

                if (pva != null) {
                    let doesDuplicateChipExist = false;
                    if (pva[rowIndex].displayName != null) {
                        for (let j = 0; j < pva[rowIndex].displayName.length; j++) {
                            if (!doesDuplicateChipExist && pva[rowIndex].displayName[j].toLowerCase() == chip.toLowerCase()) {
                                doesDuplicateChipExist = true;
                            }
                            else if (doesDuplicateChipExist && pva[rowIndex].displayName[j] == chip) {
                                pva[rowIndex].displayName.splice(j, 1);
                                return;
                            }
                        }
                    }
                }

                scope.processVariantNames();

                if (scope.allowDeleteChip[rowIndex] == null) {
                    scope.allowDeleteChip[rowIndex] = [];
                }
                // Show custom template delete button
                scope.allowDeleteChip[rowIndex][chip] = true;

                // Hide the hard coded md-chips template delete button
                setTimeout(function () {
                    angular.element(angular.element("md-chips-wrap > md-chip > div > button")).attr("style", "visibility: hidden");
                }, 150);
            }

            function getExistingVariantCombination(variantAttributes: any) {
                //check if variant name combination existed before making a new variant so that we can restore the existing data
                var variantFound = null;

                if (!variantAttributes || variantAttributes.length == 0) {
                    return variantFound;
                }

                for (var i = 0; i < scope.oldVariants.length; i++) {
                    if (!scope.oldVariants[i].variantAttributes || scope.oldVariants[i].variantAttributes.length == 0
                        || scope.oldVariants[i].variantAttributes.length != variantAttributes.length) {
                        continue;
                    }

                    var attributeDisplayNameFound = true;
                    for (var j = 0; j < scope.oldVariants[i].variantAttributes.length; j++) {
                        var oldAttribute = scope.oldVariants[i].variantAttributes[j];
                        var wasAttributeDisplayNameFound = false;
                        for (var k = 0; k < variantAttributes.length; k++) {
                            if (oldAttribute.displayName[0] == variantAttributes[k].displayName[0]
                                && oldAttribute.variantType == variantAttributes[k].variantType) {
                                wasAttributeDisplayNameFound = true;
                                break;
                            }
                        }
                        if (!wasAttributeDisplayNameFound) {
                            attributeDisplayNameFound = false;
                            break;
                        }
                    }

                    //TODO: DO WE ONLY RETURN THE "OLD" VARIANT IF IT WAS PREVIOUSLY SAVED???
                    if (attributeDisplayNameFound && !scope.variantAlreadyExists(scope.oldVariants[i])) {
                        variantFound = scope.oldVariants[i];
                        break;
                    }
                }
                return variantFound;
            }

            scope.variantAlreadyExists = (variant) => {
                for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    if (scope.context.selectedSection.model.variants[i].id == variant.id) {
                        return true;
                    }
                }
                return false;
            }

            scope.areVariantCombinationsMissing = () => {
                return scope.deletedVariantCombinations != null && scope.deletedVariantCombinations.length >= 1 && !scope.enableVariantConsolidation;
            }

            scope.revertToParentProductPackageTypeAndMultiplesOf = (item: any) => {
                if (scope.context.mode == Meevo.Model.MaintenanceFormState.Readonly)
                    return;

                item.wasChanged = true;
                item.showProductPackageTypeAndMultiplesOfRevertIndicator = false;
                if (item.multiplesOf_T != null)
                    item.multiplesOf = item.multiplesOf_T;
                else
                    item.multiplesOf = 1;
                if (item.productPackageType_T != null && item.productPackageType_T != 0)
                    item.productPackageType = item.productPackageType_T;
                else
                    item.productPackageType = ProductPackageTypeEnum.Each;

                if (!scope.context.identityService.inCentralOfficeMode() && !scope.context.identityService.checkCentralOfficeLocationId(scope.context.asLocationId)) {
                    item.nullProductPackageTypeAndMultiplesOfValuesBeforeSaving = true;
                }
            }

            scope.revertToParentModelQuantityAndOrderPoint = (item: any) => {
                if (scope.context.mode == Meevo.Model.MaintenanceFormState.Readonly)
                    return;

                item.wasChanged = true;
                item.showModelQuantityAndOrderPointRevertIndicator = false;
                if (item.modelQuantity_T != null)
                    item.modelQuantity = item.modelQuantity_T;
                else
                    item.modelQuantity = 0;
                if (item.orderPoint_T != null)
                    item.orderPoint = item.orderPoint_T;
                else
                    item.orderPoint = 0;

                if (!scope.context.identityService.inCentralOfficeMode() && !scope.context.identityService.checkCentralOfficeLocationId(scope.context.asLocationId)) {
                    item.nullModelQuantityAndOrderPointValuesBeforeSaving = true;
                }
            }

            // This method creates all of the Variants form the all of the possible combinations of attributes
            scope.processVariantNames = () => {

                scope.oldVariants = angular.copy(scope.context.selectedSection.model.variants);

                const m = scope.context.selectedSection.model;

                m.variants = [];

                if (m.productVariantAttributes == null) {
                    m.productVariantAttributes = [];
                }

                scope.createAllVariantCombinations(false);

                m.productVariantAttributes.forEach((attr) => attr.displayName.sort((a, b) => sortAlphaNum(a, b)));

                if (scope.enableVariantConsolidation) {
                    if (scope.originalVariantsCopy) {
                        // Reset markers so new consolidation attempts can reapply previously stored data after attribute changes.
                        for (let i = 0; i < scope.originalVariantsCopy.length; i++) {
                            scope.originalVariantsCopy[i].consolidated = false;
                        }
                    }
                    //Remove information of previously restored variants because the consolidation process moves that data to the begining variants
                    for (let index = scope.originalVariantsCopy.length; index < m.variants.length; index++) {
                        var newVariantId = Guid.newSqlSequentialGuid().toString();
                        m.variants[index] = {
                            displayName: m.variants[index].displayName,
                            id: newVariantId,
                            objectState: Meevo.Model.ObjectStateEnum.Active,
                            markUp: 0,
                            wholeSale: 0,
                            retail: 0,
                            notForSale: false,
                            excludePointPromotion: false,
                            variantAttributes: m.variants[index].variantAttributes,
                            sortOrder: m.variants[index].sortOrder,
                            productInventoryType: ProductInventoryTypeEnum.Retail,
                            isInventoryTrackable: 1,
                            trackLots: false,
                            trackExpirationDate: true, // 132418: Track Expiration defaults ON for new variants (editable until lots exist)
                            hasLots: false,
                            floorLocation: "",
                            floorLocations: [],
                            noOfWeeksValid: 0,
                            variantDistributorIds: [],
                            variantStockLevels: [{
                                variantId: newVariantId,
                                productPackageType: ProductPackageTypeEnum.Each,
                                productInventoryType: ProductInventoryTypeEnum.Retail,
                                multiplesOf: 1,
                                modelQuantity: 0,
                                orderPoint: 0,
                                onHand: 0,
                                wasChanged: false,
                                isDisplayed: true
                            }]
                        };
                    }

                    var previousInformation = "Variant existed before adding ";
                    for (let i = scope.originalVariantAttributesLength; i < m.productVariantAttributes.length; i++) {
                        previousInformation += scope.getAttributeDisplayName(m.productVariantAttributes[i].variantType);
                        if (i + 2 == m.productVariantAttributes.length)
                            previousInformation += " and ";
                        else if (i + 2 < m.productVariantAttributes.length)
                            previousInformation += ", ";
                    }
                    previousInformation += " attributes";

                    for (let i = 0; i < m.variants.length; i++) {
                        const variant: Meevo.Model.ProductVariant = m.variants[i];
                        variant.previousInformation = previousInformation;
                        variant.consolidatedNameFragment1 = null;
                        variant.consolidatedNameFragment2 = null;
                        variant.consolidatedNameFragment3 = null;
                    }

                    // Hide Attributes which existed beforehand
                    if (m.productVariantAttributes.length >= 1) {

                        // Sort variants to ensure consistent ordering before marking
                        // Marking logic must work regardless of generated variant order
                        scope.sortVariantsBySku();

                        // Bug 113798 Fix: Set-based marking to handle duplicate variants
                        // We mark only the FIRST occurrence of each original combination for consolidation display
                        if (scope.originalVariantAtributes.length == 2) {

                            const markedCombinations = new Set<string>();
                            let markedCount = 0;
                            const targetCount = scope.originalVariantsCopy ? scope.originalVariantsCopy.length : 0;

                            for (let i = 0; i < m.variants.length && markedCount < targetCount; i++) {

                                let variant: Meevo.Model.ProductVariant = m.variants[i];

                                // Extract the actual attribute values from this variant's variantAttributes array
                                // (not from loop indices - that would cause SKU/barcode reassignment)
                                if (variant.variantAttributes && variant.variantAttributes.length >= 2) {
                                    const fragment1 = variant.variantAttributes[0].displayName[0];
                                    const fragment2 = variant.variantAttributes[1].displayName[0];
                                    const combinationKey = `${fragment1}|${fragment2}`;

                                    // Only mark the first occurrence of each original combination
                                    if (!markedCombinations.has(combinationKey)) {

                                        variant.consolidatedNameFragment1 = fragment1;
                                        variant.consolidatedNameFragment2 = fragment2;

                                        variant.alreadyConsolidated = true;

                                        markedCombinations.add(combinationKey);
                                        markedCount++;
                                    }
                                }
                            }
                        }
                        else if (scope.originalVariantAtributes.length == 1) {

                            const markedCombinations = new Set<string>();
                            let markedCount = 0;
                            const targetCount = scope.originalVariantsCopy ? scope.originalVariantsCopy.length : 0;

                            for (let i = 0; i < m.variants.length && markedCount < targetCount; i++) {
                                let variant: Meevo.Model.ProductVariant = m.variants[i];

                                // Extract the actual attribute value from this variant's variantAttributes
                                if (variant.variantAttributes && variant.variantAttributes.length >= 1) {
                                    const fragment1 = variant.variantAttributes[0].displayName[0];

                                    // Only mark the first occurrence of each original value
                                    if (!markedCombinations.has(fragment1)) {
                                        variant.consolidatedNameFragment1 = fragment1;
                                        variant.alreadyConsolidated = true;
                                        markedCombinations.add(fragment1);
                                        markedCount++;
                                    }
                                }
                            }
                        }
                        else if (scope.originalVariantAtributes.length == 0
                                && scope.originalVariantsCopy.length == 1
                                && m.variants.length >= 1) {
                            // if there is only one "original" variant but with no attributes, 
                            //  we still need to assign the consolidatedNameFragment and mark
                            //  it as alreadyConsolidated
                            let variant: Meevo.Model.ProductVariant = m.variants[0];
                            if (variant.variantAttributes && variant.variantAttributes.length >= 1) {
                                variant.consolidatedNameFragment1 = variant.variantAttributes[0].displayName[0];
                                variant.alreadyConsolidated = true;
                            }
                        }
                    }


                    restorePreviouslySoldVariantInfo();

                    restorePreviouslySelectedConsolidatedNameFragments();

                    if (!scope.hideRemainingVariants && scope.enableVariantConsolidation) 
                        scope.PopulateAllVariantOptionDropDowns();

                }

                if (!scope.enableVariantConsolidation) scope.sortVariantsBySku();

                scope.deletedVariantCombinations = [];

            }
            function restorePreviouslySelectedConsolidatedNameFragments() {

                // Restore previously selected consolidated name fragments into the new variants

                let variants = scope.context.selectedSection.model.variants;

                if (scope.latestConsolidatedVariantsCopy != null) {

                    for (let i = 0; i < scope.latestConsolidatedVariantsCopy.length; i++) {

                        let lcvc = scope.latestConsolidatedVariantsCopy[i];
                        const vaCount = scope.context.selectedSection.model.productVariantAttributes.length;

                        if (variants.length > i) {

                            if (variants[i].consolidatedNameFragment1 == null &&
                                scope.CheckIfFirstAttributeValueExists(i) && vaCount >= 1) {
                                variants[i].consolidatedNameFragment1 = _.clone(lcvc.consolidatedNameFragment1);
                            }

                            if (variants[i].consolidatedNameFragment2 == null &&
                                scope.CheckIfSecondAttributeValueExists(i) && vaCount >= 2) {
                                variants[i].consolidatedNameFragment2 = _.clone(lcvc.consolidatedNameFragment2);
                            }
                            if (variants[i].consolidatedNameFragment3 == null &&
                                scope.CheckIfThirdAttributeValueExists(i) && vaCount >= 3) {
                                variants[i].consolidatedNameFragment3 = _.clone(lcvc.consolidatedNameFragment3);
                            }
                        }
                    }
                }
            }

            function restorePreviouslySoldVariantInfo() {

                // Restore previously sold variant information into the new variants which need to be consolidated

                let nothingWasCopied = true;
                const totalAttributes = scope.context.selectedSection.model.productVariantAttributes
                    ? scope.context.selectedSection.model.productVariantAttributes.length
                    : 0;
                const hasNewAttributes = totalAttributes > scope.originalVariantAttributesLength;
                const hasNewAttributeSelection = (variant: any) => {
                    if (!hasNewAttributes)
                        return true;
                    if (!variant)
                        return false;
                    // Honor the temporary flag so we only treat rows as having confirmed the new attributes
                    // after the dropdown population run validated them
                    if (variant.newAttributeSelectionConfirmed != null)
                        return variant.newAttributeSelectionConfirmed;
                    for (let fragmentIndex = scope.originalVariantAttributesLength + 1; fragmentIndex <= totalAttributes; fragmentIndex++) {
                        if (!variant[`consolidatedNameFragment${fragmentIndex}`]) {
                            return false;
                        }
                    }
                    return true;
                };

                for (let index = 0; index < scope.originalVariantsCopy.length; index++) {

                    // Prevent the same previous variant from seeding multiple consolidated rows in one pass
                    if (scope.originalVariantsCopy[index].consolidated)
                        continue;

                    for (let index2 = 0; index2 < scope.context.selectedSection.model.variants.length; index2++) {

                        const va = scope.originalVariantsCopy[index].variantAttributes;
                        const variantIndex2 = scope.context.selectedSection.model.variants[index2];
                        // Only restore barcode/SKU data for rows that require the new attributes and once the fragments were confirmed.
                        const requiresNewAttributeSelection = hasNewAttributes && !variantIndex2.alreadyConsolidated;

                        if (requiresNewAttributeSelection && !hasNewAttributeSelection(variantIndex2))
                            continue;

                        if (va.length == 3
                            && variantIndex2.consolidatedNameFragment1
                            && va[0].displayName[0] == variantIndex2.consolidatedNameFragment1
                            && variantIndex2.consolidatedNameFragment2
                            && va[1].displayName[0] == variantIndex2.consolidatedNameFragment2
                            && variantIndex2.consolidatedNameFragment3
                            && va[2].displayName[0] == variantIndex2.consolidatedNameFragment3
                        ) {
                            scope.CopyVariantProperties(variantIndex2, scope.originalVariantsCopy[index]);
                            nothingWasCopied = false;
                            // Flag this prior variant so it does not overwrite other combinations in this session.
                            scope.originalVariantsCopy[index].consolidated = true;
                            break;
                        }
                        else if (va.length == 2
                            && variantIndex2.consolidatedNameFragment1
                            && va[0].displayName[0] == variantIndex2.consolidatedNameFragment1
                            && variantIndex2.consolidatedNameFragment2
                            && va[1].displayName[0] == variantIndex2.consolidatedNameFragment2
                        ) {
                            scope.CopyVariantProperties(variantIndex2, scope.originalVariantsCopy[index]);
                            nothingWasCopied = false;
                            // Flag this prior variant so it does not overwrite other combinations in this session.
                            scope.originalVariantsCopy[index].consolidated = true;
                            break;
                        }
                        else if (va.length == 1 &&
                            variantIndex2.consolidatedNameFragment1
                            && va[0].displayName[0] == variantIndex2.consolidatedNameFragment1
                        ) {
                            scope.CopyVariantProperties(variantIndex2, scope.originalVariantsCopy[index]);
                            nothingWasCopied = false;
                            // Flag this prior variant so it does not overwrite other combinations in this session.
                            scope.originalVariantsCopy[index].consolidated = true;
                            break;
                        }
                        else if (va.length == 0 && scope.enableVariantConsolidation) {
                            scope.CopyVariantProperties(variantIndex2, scope.originalVariantsCopy[index]);
                            nothingWasCopied = false;
                            scope.originalVariantsCopy[index].consolidated = true;
                            break;
                        }
                        else if (nothingWasCopied && scope.context.selectedSection.backup.variants.length == 1 && scope.context.selectedSection.backup.variants[0].variantAttributes.length == 0 && scope.enableVariantConsolidation) {
                            scope.CopyVariantProperties(variantIndex2, scope.originalVariantsCopy[index]);
                            nothingWasCopied = false;
                            scope.originalVariantsCopy[index].consolidated = true;
                            break;
                        }
                    }
                }

            }

            function sortAlphaNum(a, b) {
                return (a != null && b != null) ? a.localeCompare(b) : 0;
            }

            function pushVariantWithAttribute(name: string, id: string, variantAttributes: any, variantSortOrder: number, name1: string, name2: string, name3: string) {
                var variantToAdd = null;

                if (!scope.enableVariantConsolidation) {
                    variantToAdd = getExistingVariantCombination(variantAttributes);
                }

                if (!variantToAdd) { // was not able to find the same combination of variants
                    variantToAdd = {
                        id: id,
                        objectState: Meevo.Model.ObjectStateEnum.Active,
                        markUp: 0,
                        wholeSale: 0,
                        retail: 0,
                        notForSale: false,
                        excludePointPromotion: false,
                        variantAttributes: variantAttributes,
                        productInventoryType: ProductInventoryTypeEnum.Retail,
                        isInventoryTrackable: 1,
                        trackLots: false,
                        trackExpirationDate: true, // 132418: Track Expiration defaults ON for new variants (editable until lots exist)
                        hasLots: false,
                        floorLocation: "",
                        floorLocations: [],
                        noOfWeeksValid: 0,
                        variantDistributorIds: [],
                        variantStockLevels: [
                            {
                                variantId: id,
                                productPackageType: ProductPackageTypeEnum.Each,
                                productInventoryType: ProductInventoryTypeEnum.Retail,
                                multiplesOf: 1,
                                modelQuantity: 0,
                                orderPoint: 0,
                                onHand: 0,
                                wasChanged: false,
                                isDisplayed: true
                            },
                            {
                                variantId: id,
                                productPackageType: ProductPackageTypeEnum.Each,
                                productInventoryType: ProductInventoryTypeEnum.ShopSupply,
                                multiplesOf: 1,
                                modelQuantity: 0,
                                orderPoint: 0,
                                onHand: 0,
                                wasChanged: false
                            }
                        ]
                    };
                }
                else {
                    variantAttributes.forEach((attr) => attr.id = variantToAdd.id);
                    variantToAdd.variantAttributes = variantAttributes;
                }
                variantToAdd.displayName = name;
                variantToAdd.sortOrder = variantSortOrder;

                scope.context.selectedSection.model.variants.push(variantToAdd);
            }
            // Determines if a variant is in "consolidated" state for styling/validation
            scope.isVariantConsolidated = (variant: any) => {

                /*
                NOTE: This is different from variant.alreadyConsolidated flag
                    - alreadyConsolidated: Controls visibility (show/hide rows) - set by processVariantNames()
                    - isVariantConsolidated(): Controls styling/validation in productVariantProperties.html
                        (blur effects, red borders on SKU/barcode inputs, validation states)
                */
                if (!variant) {
                    return false;
                }
                
                /*
                Quick check: if fragment1 is populated, this variant is consolidated
                (either marked as alreadyConsolidated OR a duplicate variant with fragments)
                This ensures proper styling/validation for all consolidated variants in the template
                Removing this check will cause marked variants to be styled incorrectly
                */
                else if ((variant.consolidatedNameFragment1) && (variant.consolidatedNameFragment1.length > 0)) {
                    return true;
                }
                
                // Check if required fragments are missing based on how many original attributes existed
                // Returns false if consolidation is enabled but required fragments aren't set yet
                else if (scope.enableVariantConsolidation
                    && ((scope.originalVariantAttributesLength == 0 && !variant.consolidatedNameFragment1)
                        || (scope.originalVariantAttributesLength == 1 && (!variant.consolidatedNameFragment1 || !variant.consolidatedNameFragment2))
                        || (scope.originalVariantAttributesLength == 2 && (!variant.consolidatedNameFragment1 || !variant.consolidatedNameFragment2 || !variant.consolidatedNameFragment3))))
                    return false;
                else
                    return true;
            }

            scope.CheckIfFirstAttributeValueExists = (i) => {
                let valueExists = false;
                if (scope.context.selectedSection.model.productVariantAttributes.length >= 1) {
                    for (let j = 0; j < scope.context.selectedSection.model.productVariantAttributes[0].displayName.length; j++) {
                        if (scope.latestConsolidatedVariantsCopy[i].consolidatedNameFragment1 == scope.context.selectedSection.model.productVariantAttributes[0].displayName[j]) {
                            valueExists = true;
                            break;
                        }
                    }
                }
                return valueExists;
            }

            scope.CheckIfSecondAttributeValueExists = (i) => {
                let valueExists = false;
                if (scope.context.selectedSection.model.productVariantAttributes.length >= 2) {
                    for (let j = 0; j < scope.context.selectedSection.model.productVariantAttributes[1].displayName.length; j++) {
                        if (scope.latestConsolidatedVariantsCopy[i].consolidatedNameFragment2 == scope.context.selectedSection.model.productVariantAttributes[1].displayName[j]) {
                            valueExists = true;
                            break;
                        }
                    }
                }
                return valueExists;
            }

            scope.CheckIfThirdAttributeValueExists = (i) => {
                let valueExists = false;
                if (scope.context.selectedSection.model.productVariantAttributes.length >= 3) {
                    for (let j = 0; j < scope.context.selectedSection.model.productVariantAttributes[2].displayName.length; j++) {
                        if (scope.latestConsolidatedVariantsCopy[i].consolidatedNameFragment3 == scope.context.selectedSection.model.productVariantAttributes[2].displayName[j]) {
                            valueExists = true;
                            break;
                        }
                    }
                }
                return valueExists;
            }

            scope.didVariantExistBefore = (id) => {
                var existedBefore = false;

                for (let j = 0; j < scope.context.selectedSection.model.variants.length; j++) {

                    if (scope.context.selectedSection.model.variants[j].fromDB
                        && id == scope.context.selectedSection.model.variants[j].id) {
                        existedBefore = true;
                        break;
                    }
                }
                return existedBefore;
            }

            // When user flips the switch for single or multiple variants re-initialize variant data properly
            scope.processObjectStateChange = () => {
                if (scope.hasVariantToConsolidate) {
                    // this is an edit of an existing product with no attributes
                    scope.startVariantConsolidation();
                    // should exit here since we want to keep existing data
                    return;
                }

                // this is only done when creating a new Product (no variants / no attributes yet)
                scope.processVariantNames();
                scope.limitAttributeCharLength();

                scope.context.selectedSection.model.productVariantAttributes = null;
                scope.context.selectedSection.model.variants = [];

                // the value of "scope.hasVariants" is the previous value since ngChange is called before the model has been updated
                // if the state is changing from Active to Inactive, then user selected to have no Attributes, therefore add a blank variant
                // if the state is changing from Inactive to Active, then user selected to add Attributes, therefore no need to add a blank variant
                //   as variants will get added as the user adds attribute values.
                if (scope.hasVariants == Meevo.Model.ObjectStateEnum.Active) {
                    scope.pushVariant(null);
                }
            }

            scope.hideSelectedAttributes = (attributeName) => {
                for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    if (scope.originalVariantAttributesLength == 1 &&
                        (scope.context.selectedSection.model.variants[i].consolidatedNameFragment1 == attributeName
                            || scope.context.selectedSection.model.variants[i].consolidatedNameFragment2 == attributeName
                            || scope.context.selectedSection.model.variants[i].consolidatedNameFragment3 == attributeName))
                        return true;
                }

                return false;
            }

            // After Removing a Variant Re-process variant names
            scope.removeVariant = (row, chip) => {
                scope.processVariantNames();
            }

            // Removes item from variantName Array, and productVariations object
            scope.trashVariant = (rowIndex, chip: any) => {
                for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    if (scope.context.selectedSection.model.variants[i].displayName == chip) {
                        scope.deletedVariantCombinations.push(scope.context.selectedSection.model.variants[i]);
                        scope.context.selectedSection.model.variants.splice(i, 1);
                    }
                }
                if (scope.context.selectedSection.model.variants.length === 0) {
                    scope.hasVariantToConsolidate = false;
                    scope.hasVariants = Meevo.Model.ObjectStateEnum.Inactive;
                    scope.processObjectStateChange();
                }
            }

            scope.addAttribute = () => {
                if (scope.context.selectedSection.model.productVariantAttributes == null)
                    scope.context.selectedSection.model.productVariantAttributes = [];

                if (!scope.enableVariantConsolidation && scope.context.selectedSection.model.id != null) {
                    scope.startVariantConsolidation();
                    scope.hideRemainingVariants = true;
                    scope.renamingChip = false;
                    scope.chipRowBeingRenamed = null;
                    scope.chipBeingRenamed = null;
                }

                //scope.context.selectedSection.model.productVariantAttributes.push({ index: indexNum, variantName: [], productVariations: [] });
                scope.context.selectedSection.model.productVariantAttributes.push({ id: Guid.newSqlSequentialGuid().toString(), index: scope.context.selectedSection.model.productVariantAttributes.length, displayName: [], productVariations: [], variantType: null, sortOrder: scope.context.selectedSection.model.productVariantAttributes.length });

                scope.limitAttributeCharLength();
            }

            // Removes attribute: color, size, length etc...
            scope.removeAttribute = (index: number) => {
                if (scope.context.selectedSection.model.productVariantAttributes.length > 0) {
                    scope.context.selectedSection.model.productVariantAttributes.splice(index, 1);
                    scope.processNewIndexs();
                    scope.processVariantNames();

                    if (scope.context.selectedSection.model.productVariantAttributes.length == scope.originalVariantAttributesLength) {
                        scope.enableVariantConsolidation = false;
                    }

                    if (scope.context.selectedSection.model.productVariantAttributes.length == 1) {
                        for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                            for (var j = 0; j < scope.oldVariants.length; j++) {
                                if (scope.oldVariants[j].fromDB
                                    && scope.context.selectedSection.model.variants[i].variantAttributes[0].variantType == scope.oldVariants[j].variantAttributes[0].variantType
                                    && scope.oldVariants[j].variantAttributes[0].displayName[0] == scope.context.selectedSection.model.variants[i].variantAttributes[0].displayName[0]) {
                                    scope.CopyVariantProperties(scope.context.selectedSection.model.variants[i], scope.oldVariants[j]);
                                    scope.context.selectedSection.model.variants[i].consolidatedNameFragment1 = scope.context.selectedSection.model.variants[i].variantAttributes[0].displayName[0];
                                    break;
                                }
                            }
                        }
                    }
                    else if (scope.context.selectedSection.model.productVariantAttributes.length == 2) {
                        for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                            for (var j = 0; j < scope.oldVariants.length; j++) {
                                if (scope.oldVariants[j].fromDB
                                    && scope.context.selectedSection.model.variants[i].variantAttributes[0].variantType == scope.oldVariants[j].variantAttributes[0].variantType
                                    && scope.oldVariants[j].variantAttributes[0].displayName[0] == scope.context.selectedSection.model.variants[i].variantAttributes[0].displayName[0]
                                    && scope.context.selectedSection.model.variants[i].variantAttributes[1].variantType == scope.oldVariants[j].variantAttributes[1].variantType
                                    && scope.oldVariants[j].variantAttributes[1].displayName[0] == scope.context.selectedSection.model.variants[i].variantAttributes[1].displayName[0]
                                ) {
                                    scope.CopyVariantProperties(scope.context.selectedSection.model.variants[i], scope.oldVariants[j]);
                                    scope.context.selectedSection.model.variants[i].consolidatedNameFragment1 = scope.context.selectedSection.model.variants[i].variantAttributes[0].displayName[0];
                                    scope.context.selectedSection.model.variants[i].consolidatedNameFragment2 = scope.context.selectedSection.model.variants[i].variantAttributes[1].displayName[0];
                                    break;
                                }
                                // If The Middle Attribute was deleted
                                else if (scope.oldVariants[j].fromDB
                                    && scope.context.selectedSection.model.variants[i].variantAttributes[0].variantType == scope.oldVariants[j].variantAttributes[0].variantType
                                    && scope.oldVariants[j].variantAttributes[0].displayName[0] == scope.context.selectedSection.model.variants[i].variantAttributes[0].displayName[0]
                                    && scope.context.selectedSection.model.variants[i].variantAttributes[1].variantType == scope.oldVariants[j].variantAttributes[2].variantType
                                    && scope.oldVariants[j].variantAttributes[2].displayName[0] == scope.context.selectedSection.model.variants[i].variantAttributes[1].displayName[0]
                                ) {
                                    scope.CopyVariantProperties(scope.context.selectedSection.model.variants[i], scope.oldVariants[j]);
                                    scope.context.selectedSection.model.variants[i].consolidatedNameFragment1 = scope.context.selectedSection.model.variants[i].variantAttributes[0].displayName[0];
                                    scope.context.selectedSection.model.variants[i].consolidatedNameFragment2 = scope.context.selectedSection.model.variants[i].variantAttributes[1].displayName[0];
                                    break;
                                }
                            }
                        }
                    }
                    scope.deletedVariantCombinations = [];
                }
            }

            scope.addDeletedVariant = () => {
                for (var i = 0; i < scope.deletedVariantCombinations.length; i++) {
                    if (scope.deletedVariantCombinations[i].id == scope.context.variantIdToAdd) {
                        scope.context.selectedSection.model.variants.unshift(scope.deletedVariantCombinations[i]);
                        scope.deletedVariantCombinations.splice(i, 1);
                        scope.context.variantIdToAdd = null;
                        return;
                    }
                }
            }

            scope.createAllVariantCombinations = (onlyAddDeletedCombinations: boolean) => {

                var numAttributeTypes = scope.context.selectedSection.model.productVariantAttributes.length;
                if (numAttributeTypes == 0 && onlyAddDeletedCombinations == false) {
                    return;
                }
                var aLen: number = scope.context.selectedSection.model.productVariantAttributes[0].displayName.length;
                var bLen: number = (numAttributeTypes > 1) ? scope.context.selectedSection.model.productVariantAttributes[1].displayName.length : 0;
                var cLen: number = (numAttributeTypes > 2) ? scope.context.selectedSection.model.productVariantAttributes[2].displayName.length : 0;
                var variantSortOrder = 1;
                var totalCombination: number = getTotalCombination();
                for (var i = 0; i < totalCombination; i++) {
                    var c: number = (cLen > 0) ? i % cLen : 0;
                    var forB: number = (cLen > 0) ? Math.floor(i / cLen) : i;
                    var b: number = (bLen > 0) ? forB % bLen : 0;
                    var forA: number = (bLen > 0) ? Math.floor(forB / bLen) : forB;
                    var a: number = (aLen > 0) ? forA % aLen : 0;

                    var aDisplayName: string = (aLen > 0) ? scope.context.selectedSection.model.productVariantAttributes[0].displayName[a] : null;
                    var bDisplayName: string = (bLen > 0) ? scope.context.selectedSection.model.productVariantAttributes[1].displayName[b] : null;
                    var cDisplayName: string = (cLen > 0) ? scope.context.selectedSection.model.productVariantAttributes[2].displayName[c] : null;

                    var displayName: string = [aDisplayName, bDisplayName, cDisplayName].join(" ").trim();
                    var variantGuid: Guid = Guid.newSqlSequentialGuid();
                    var variantGuidStr: string = variantGuid.toString();
                    var variantAttributes: any[] = [{
                        id: variantGuidStr,
                        variantType: scope.context.selectedSection.model.productVariantAttributes[0].variantType,
                        displayName: [aDisplayName],
                        sortOrder: a + 1
                    }];
                    if (bLen > 0) {
                        variantAttributes[variantAttributes.length] = {
                            id: variantGuidStr,
                            variantType: scope.context.selectedSection.model.productVariantAttributes[1].variantType,
                            displayName: [bDisplayName],
                            sortOrder: b + 1001
                        };
                    }
                    if (cLen > 0) {
                        variantAttributes[variantAttributes.length] = {
                            id: variantGuidStr,
                            variantType: scope.context.selectedSection.model.productVariantAttributes[2].variantType,
                            displayName: [cDisplayName],
                            sortOrder: c + 2001
                        };
                    }

                    if (onlyAddDeletedCombinations) {

                        var foundVariant = _.find(scope.context.selectedSection.model.variants, function (item) {
                            return item["displayName"] == displayName;
                        });

                        if (!foundVariant) {
                            pushDeletedVariantWithAttribute(displayName, variantGuidStr, variantAttributes, variantSortOrder);
                        }
                    }
                    else {
                        pushVariantWithAttribute(displayName, variantGuidStr, variantAttributes, variantSortOrder, aDisplayName, bDisplayName, cDisplayName);
                    }

                    variantSortOrder++;
                }
            }

            function pushDeletedVariantWithAttribute(name: string, id: string, variantAttributes: any, variantSortOrder: number) {

                var variantToAdd = {
                    id: id,
                    objectState: Meevo.Model.ObjectStateEnum.Active,
                    displayName: name,
                    markUp: 0,
                    wholeSale: 0,
                    retail: 0,
                    notForSale: false,
                    excludePointPromotion: false,
                    variantAttributes: variantAttributes,
                    productInventoryType: ProductInventoryTypeEnum.Retail,
                    isInventoryTrackable: 1,
                    trackLots: false,
                    trackExpirationDate: true, // 132418: Track Expiration defaults ON for new variants (editable until lots exist)
                    hasLots: false,
                    floorLocation: "",
                    floorLocations: [],
                    noOfWeeksValid: 0,
                    variantDistributorIds: [],
                    variantStockLevels: [
                        {
                            variantId: id,
                            productPackageType: ProductPackageTypeEnum.Each,
                            productInventoryType: ProductInventoryTypeEnum.Retail,
                            multiplesOf: 1,
                            modelQuantity: 0,
                            orderPoint: 0,
                            onHand: 0,
                            wasChanged: false,
                            isDisplayed: true
                        },
                        {
                            variantId: id,
                            productPackageType: ProductPackageTypeEnum.Each,
                            productInventoryType: ProductInventoryTypeEnum.ShopSupply,
                            multiplesOf: 1,
                            modelQuantity: 0,
                            orderPoint: 0,
                            onHand: 0,
                            wasChanged: false
                        }
                    ],
                    sortOrder: variantSortOrder
                };

                scope.deletedVariantCombinations.push(variantToAdd);
            }

            // Re-assign proper indexs after a variant attribute is removed
            scope.processNewIndexs = () => {
                for (var i = 0; i < scope.context.selectedSection.model.productVariantAttributes.length; i++) {
                    scope.context.selectedSection.model.productVariantAttributes[i].index = i;
                }
            }

            // Show/Hide Discontinued and NotForSale UI options for each Variant
            scope.showVariant = (keyrowIndex, variantName) => {
                if (keyrowIndex != null && scope.enableVariantConsolidation) // dont show details until variant consolidation is complete
                    return;

                _.each(scope.context.selectedSection.model.variants, (value: any, key) => {
                    if (value.displayName == variantName) {
                        if (!scope.context.selectedSection.model.variants[key].showVariantOptions)
                            scope.context.selectedSection.model.variants[key].showVariantOptions = true;
                        else
                            scope.context.selectedSection.model.variants[key].showVariantOptions = false;
                        return;
                    }
                });
            }

            // Calculate Pricing for Variants when 2 out of 3 of the fields are filled out or when all three are filled out
            scope.processPricing = (variant: any, currentlyEditing: string) => {
                if (currentlyEditing == "Wholesale") {
                    if (variant.markUp == 0) {
                        //if (variant.wholeSale > 0) {
                        variant.retail = variant.wholeSale;
                        //}
                    }
                    else {
                        if (variant.wholeSale > 0 && (variant.wholeSale <= variant.retail)) {
                            variant.markUp = ((variant.retail - variant.wholeSale) / variant.wholeSale).toFixed(4);
                        }
                        else {
                            variant.markUp = 0.0;
                        }
                    }
                }
                else if (currentlyEditing == "Retail") {
                    if (variant.wholeSale > 0 && (variant.wholeSale <= variant.retail)) {
                        variant.markUp = ((variant.retail - variant.wholeSale) / variant.wholeSale).toFixed(4);
                    }
                    else {
                        variant.markUp = 0.0
                    }
                }
                else /* if (currentlyEditing == "Markup") */ {
                    if (variant.wholeSale > 0) {
                        variant.retail = (variant.wholeSale + (variant.wholeSale * variant.markUp)).toFixed(2);
                    }
                }
            }
            scope.setUpMarketPricing = (variant:any) => {
                event.stopPropagation();
                var modalOptions: Meevo.Plugins.Product.MarketPricingModalOptions = {
                    id: scope.context.selectedSection.model.id,
                    variantId: variant.id, 
                    parentType: Meevo.Plugins.Product.ProductInfoModalParent.Product,
                    title: this.$translate.instant('HEADER_MARKET_PRICING') + ' - ' + variant.sku + ' : ' + scope.context.selectedSection.model.displayName + ' - ' + (variant.displayName ? variant.displayName : '') ,// Modal title: Market Pricing - [<SKU/Code>: <Display Name> - <Value of Attribute 1> <Attr2> <Attr3>
                    productVariant: variant
                };
                
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/plugins/product/modals/marketPricing.template.html",
                    controller: "meevo.plugins.product.MarketPricingController",
                    controllerAs: "vm",
                    bindToController: true,
                    escapeToClose: true,
                    locals: {
                        options: modalOptions
                    }
                }
                scope.context.modalService.showCustom(options);
            }
            scope.deleteMarketPricing = () => {
                alert("Delete Market Pricing coming soon!");
            }
            scope.checkIfAlreadyConsolidated = (variant: any) => {
                var alreadyUsed = false;
                for (let i = 0; i < scope.context.selectedSection.model.variants.length; i++) {

                    const variant = scope.context.selectedSection.model.variants[i];

                    if (scope.context.selectedSection.model.productVariantAttributes.length == 1 &&
                        variant.id != variant.id &&
                        variant.consolidatedNameFragment1 == variant.consolidatedNameFragment1) {
                        alreadyUsed = true;
                        break;
                    }
                    else if (scope.context.selectedSection.model.productVariantAttributes.length == 2 &&
                        variant.id != variant.id &&
                        variant.consolidatedNameFragment1 == variant.consolidatedNameFragment1 &&
                        variant.consolidatedNameFragment2 == variant.consolidatedNameFragment2) {
                        alreadyUsed = true;
                        break;
                    }
                    else if (scope.context.selectedSection.model.productVariantAttributes.length == 3 &&
                        variant.id != variant.id &&
                        variant.consolidatedNameFragment1 == variant.consolidatedNameFragment1 &&
                        variant.consolidatedNameFragment2 == variant.consolidatedNameFragment2 &&
                        variant.consolidatedNameFragment3 == variant.consolidatedNameFragment3) {
                        alreadyUsed = true;
                        break;
                    }
                }
                return alreadyUsed;
            }

            scope.isVariantReadonly = (variant) => {
                if (!scope.context.isReadonly
                    && scope.context.isAccessible
                    && scope.enableVariantConsolidation
                    && ((scope.originalVariantAttributesLength == 0 && !variant.consolidatedNameFragment1)
                        || (scope.originalVariantAttributesLength == 1 && (!variant.consolidatedNameFragment1 || !variant.consolidatedNameFragment2))
                        || (scope.originalVariantAttributesLength == 2 && (!variant.consolidatedNameFragment1 || !variant.consolidatedNameFragment2 || !variant.consolidatedNameFragment3))
                    )) {
                    //return scope.context.modalService.alert("Please select values for each of the attributes in the variant before editing the variant.", 0).then(() => { return true; });
                    return true;
                }
                return false;
            }

            scope.generateRemainingVariants = () => {

                var numberOfVariantsConsolidated = 0;
                const m = scope.context.selectedSection.model;

                //validation
                for (var i = 0; i < m.variants.length; i++) {

                    if (m.productVariantAttributes.length == 1 && m.variants[i].consolidatedNameFragment1) {
                        numberOfVariantsConsolidated = numberOfVariantsConsolidated + 1;
                    }
                    else if (m.productVariantAttributes.length == 2 && m.variants[i].consolidatedNameFragment1 && m.variants[i].consolidatedNameFragment2) {
                        numberOfVariantsConsolidated = numberOfVariantsConsolidated + 1;
                    }
                    else if (m.productVariantAttributes.length == 3 && m.variants[i].consolidatedNameFragment1 && m.variants[i].consolidatedNameFragment2 && m.variants[i].consolidatedNameFragment3) {
                        numberOfVariantsConsolidated = numberOfVariantsConsolidated + 1;
                    }
                }

                // failed validation
                if (scope.originalVariantsCopy && numberOfVariantsConsolidated < scope.originalVariantsCopy.length) {
                    scope.context.modalService.alert("Please select values for each of the attributes in the variants above.", 0);
                    return;
                }

                // Index for current Variant to copy over
                // this is an important process which correctly sets up variants based on the selected attribute values like: Color; Red
                for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    var consolidatedVariantName = "";

                    if (scope.context.selectedSection.model.productVariantAttributes.length == 1) {
                        consolidatedVariantName = scope.context.selectedSection.model.variants[i].consolidatedNameFragment1;
                    }
                    else if (scope.context.selectedSection.model.productVariantAttributes.length == 2) {
                        consolidatedVariantName = scope.context.selectedSection.model.variants[i].consolidatedNameFragment1 + " " + scope.context.selectedSection.model.variants[i].consolidatedNameFragment2;
                    }
                    else if (scope.context.selectedSection.model.productVariantAttributes.length == 3) {
                        consolidatedVariantName = scope.context.selectedSection.model.variants[i].consolidatedNameFragment1 + " " + scope.context.selectedSection.model.variants[i].consolidatedNameFragment2 + " " + scope.context.selectedSection.model.variants[i].consolidatedNameFragment3;
                    }

                    if (consolidatedVariantName != "") {
                        for (let j = 0; j < scope.context.selectedSection.model.variants.length; j++) {
                            if (scope.context.selectedSection.model.variants[j].displayName == consolidatedVariantName) {

                                scope.FindAndSwapVariantDisplayNameAndAttributes(scope.context.selectedSection.model.variants[i], scope.context.selectedSection.model.variants[j]);

                            }
                        }
                    }
                }

                // Populate all of the dropdowns with all of the remaining possible combinations
                scope.PopulateAllVariantOptionDropDowns();

                if (scope.originalVariantsCopy && scope.originalVariantsCopy.length > 0) {
                    // Restore barcode/SKU data for previously saved variants before showing remaining combinations.
                    restorePreviouslySoldVariantInfo();
                }

                scope.enableVariantConsolidation = false;
                scope.hideRemainingVariants = false;

                // Scroll to first invalid/incomplete variant after DOM updates
                // Use $timeout with 0 to wait for Angular digest cycle, then additional delay for DOM rendering
                this.$timeout(() => {
                    const firstInvalid = document.querySelector('.red_border_invalid, .ng-invalid-required');
                    if (firstInvalid) {
                        // Find the parent variant card to scroll to
                        const variantCard = firstInvalid.closest('.meevo-card-layout') || firstInvalid;
                        variantCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);

            }

            scope.PopulateAllVariantOptionDropDowns = () => {

                let model = scope.context.selectedSection.model;

                // Populate all of the dropdowns with all of the remaining possible combinations
                if (model.productVariantAttributes.length == 1) {

                    for (let i = 0; i < model.productVariantAttributes[0].displayName.length; i++) {
                        var isNameUsed = false;
                        for (let x = 0; x < model.variants.length; x++) {
                            if (model.variants[x].consolidatedNameFragment1 == model.productVariantAttributes[0].displayName[i]) {
                                isNameUsed = true;
                                break;
                            }
                        }
                        if (!isNameUsed) {
                            for (let x = 0; x < model.variants.length; x++) {
                                if (model.variants[x].consolidatedNameFragment1 == null) {
                                    model.variants[x].consolidatedNameFragment1 = model.productVariantAttributes[0].displayName[i];
                                    break;
                                }
                            }
                        }
                    }

                }
                else if (model.productVariantAttributes.length == 2) {

                    for (let i = 0; i < model.productVariantAttributes[0].displayName.length; i++) {
                        for (let j = 0; j < model.productVariantAttributes[1].displayName.length; j++) {
                            var isNameUsed = false;
                            for (let x = 0; x < model.variants.length; x++) {
                                if (model.variants[x].consolidatedNameFragment1 == model.productVariantAttributes[0].displayName[i]
                                    && model.variants[x].consolidatedNameFragment2 == model.productVariantAttributes[1].displayName[j]
                                ) {
                                    isNameUsed = true;
                                    break;
                                }
                            }
                            if (!isNameUsed) {
                                for (let x = 0; x < model.variants.length; x++) {
                                    if (model.variants[x].consolidatedNameFragment1 == null &&
                                        model.variants[x].consolidatedNameFragment2 == null) {
                                        model.variants[x].consolidatedNameFragment1 = model.productVariantAttributes[0].displayName[i];
                                        model.variants[x].consolidatedNameFragment2 = model.productVariantAttributes[1].displayName[j];
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                else if (model.productVariantAttributes.length == 3) {

                    for (let i = 0; i < model.productVariantAttributes[0].displayName.length; i++) {
                        for (let j = 0; j < model.productVariantAttributes[1].displayName.length; j++) {
                            for (let k = 0; k < model.productVariantAttributes[2].displayName.length; k++) {
                                var isNameUsed = false;
                                for (let x = 0; x < model.variants.length; x++) {
                                    if (model.variants[x].consolidatedNameFragment1 == model.productVariantAttributes[0].displayName[i]
                                        && model.variants[x].consolidatedNameFragment2 == model.productVariantAttributes[1].displayName[j]
                                        && model.variants[x].consolidatedNameFragment3 == model.productVariantAttributes[2].displayName[k]
                                    ) {
                                        isNameUsed = true;
                                        break;
                                    }
                                }
                                if (!isNameUsed) {
                                    for (let x = 0; x < model.variants.length; x++) {
                                        let v = model.variants[x];
                                        if (v.consolidatedNameFragment1 == null &&
                                            v.consolidatedNameFragment2 == null &&
                                            v.consolidatedNameFragment3 == null) {
                                            v.consolidatedNameFragment1 = model.productVariantAttributes[0].displayName[i];
                                            v.consolidatedNameFragment2 = model.productVariantAttributes[1].displayName[j];
                                            v.consolidatedNameFragment3 = model.productVariantAttributes[2].displayName[k];
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            scope.generateVariantsAttributes = () => {

                const m = scope.context.selectedSection.model;

                scope.latestConsolidatedVariantsCopy = [];

                for (let i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    scope.latestConsolidatedVariantsCopy.push(_.clone(scope.context.selectedSection.model.variants[i]));
                }

                let numberOfVariantsConsolidated = 0;

                // Validation
                let attributeLength = m.productVariantAttributes.length;

                m.variants.forEach((variant: Meevo.Model.ProductVariant) => {

                    if (attributeLength == 1 && variant.consolidatedNameFragment1) {
                        numberOfVariantsConsolidated = numberOfVariantsConsolidated + 1;
                    }
                    else if (attributeLength == 2 && variant.consolidatedNameFragment1 && variant.consolidatedNameFragment2) {
                        numberOfVariantsConsolidated = numberOfVariantsConsolidated + 1;
                    }
                    else if (attributeLength == 3 && variant.consolidatedNameFragment1 && variant.consolidatedNameFragment2 && variant.consolidatedNameFragment3) {
                        numberOfVariantsConsolidated = numberOfVariantsConsolidated + 1;
                    }
                });

                // Ensure that there are not less consolidated variants then were in the original copy
                if (numberOfVariantsConsolidated < scope.originalVariantsCopy.length) {
                    return;
                }

                m.variants.forEach((variant: Meevo.Model.ProductVariant) => {

                    let consolidatedVariantName = "";

                    if (m.productVariantAttributes.length == 1) {
                        consolidatedVariantName = variant.consolidatedNameFragment1;
                    }
                    else if (m.productVariantAttributes.length == 2) {
                        consolidatedVariantName = variant.consolidatedNameFragment1 + " " + variant.consolidatedNameFragment2;
                    }
                    else if (m.productVariantAttributes.length == 3) {
                        consolidatedVariantName = variant.consolidatedNameFragment1 + " " + variant.consolidatedNameFragment2 + " " + variant.consolidatedNameFragment3;
                    }

                    if (consolidatedVariantName != "") {
                        m.variants.forEach((v: Meevo.Model.ProductVariant) => {
                            if (v.displayName == consolidatedVariantName) {
                                scope.FindAndSwapVariantDisplayNameAndAttributes(variant, v);
                            }
                        });
                    }
                });

                // Record whether each variant already has dropdown selections for every newly added attribute.
                const totalAttributes = m.productVariantAttributes.length;
                const hasNewAttributes = totalAttributes > scope.originalVariantAttributesLength;

                if (hasNewAttributes) {
                    for (let i = 0; i < m.variants.length; i++) {
                        const variant = m.variants[i];
                        let confirmed = true;
                        for (let fragmentIndex = scope.originalVariantAttributesLength + 1; fragmentIndex <= totalAttributes; fragmentIndex++) {
                            if (!variant[`consolidatedNameFragment${fragmentIndex}`]) {
                                confirmed = false;
                                break;
                            }
                        }
                        variant.newAttributeSelectionConfirmed = confirmed;
                    }
                }


                // Populate all of the dropdowns with all of the remaining possible combinations
                scope.PopulateAllVariantOptionDropDowns();

                if (scope.originalVariantsCopy && scope.originalVariantsCopy.length > 0) {
                    // Restore saved variant info so barcode/SKU fields stay populated when selecting fragments.
                    restorePreviouslySoldVariantInfo();
                    m.variants.forEach((variant) => {
                        delete variant.newAttributeSelectionConfirmed;
                    });
                }

                for (let k = 0; k < m.variants.length; k++) {
                    for (let x = 0; x < m.variants[k].variantAttributes.length; x++) {
                        if (m.variants[k].id != m.variants[k].variantAttributes[x].id) {
                            m.variants[k].variantAttributes[x].id = m.variants[k].id;
                        }
                    }
                }
            }

            scope.hideVariantAttributeOption = (attribute, variant, section) => {
                // if an attribute value is already applied to a variant, hide it from other variant(s) to prevent duplicates
                var isHidden = false;
                const variants = scope.context.selectedSection.model.variants;
                for (let j = 0; j < variants.length; j++) {
                    if (variants[j].id != variant.id
                        && ((section == 1
                            && attribute == variants[j].consolidatedNameFragment1
                            && variant.consolidatedNameFragment2 == variants[j].consolidatedNameFragment2
                            && variant.consolidatedNameFragment3 == variants[j].consolidatedNameFragment3)
                        || (section == 2
                            && attribute == variants[j].consolidatedNameFragment2
                            && variant.consolidatedNameFragment1 == variants[j].consolidatedNameFragment1
                            && variant.consolidatedNameFragment3 == variants[j].consolidatedNameFragment3)
                        || (section == 3
                            && attribute == variants[j].consolidatedNameFragment3
                            && variant.consolidatedNameFragment1 == variants[j].consolidatedNameFragment1
                            && variant.consolidatedNameFragment2 == variants[j].consolidatedNameFragment2))
                    ) {
                        isHidden = true;
                        break;
                    }
                }

                return isHidden;
            }

            scope.CopyVariantProperties = (copyTo: any, copyFrom: any) => {
                copyTo.id = copyFrom.id;
                copyTo.barCode = copyFrom.barCode;
                copyTo.entityVersion = copyFrom.entityVersion;
                copyTo.floorLocations = copyFrom.floorLocations;
                copyTo.fromDB = copyFrom.fromDB;
                copyTo.isBarCodeValid = copyFrom.isBarCodeValid;
                copyTo.isDiscontinued = copyFrom.isDiscontinued;
                copyTo.isInventoryTrackable = copyFrom.isInventoryTrackable;
                copyTo.trackLots = copyFrom.trackLots;
                copyTo.trackExpirationDate = copyFrom.trackExpirationDate;
                copyTo.hasLots = copyFrom.hasLots;
                copyTo.isSkuValid = copyFrom.isSkuValid;
                copyTo.markUp = copyFrom.markUp;
                copyTo.noOfWeeksValid = copyFrom.noOfWeeksValid;
                copyTo.notForSale = copyFrom.notForSale;
                copyTo.excludePointPromotion = copyFrom.excludePointPromotion;
                copyTo.objectState = copyFrom.objectState;
                copyTo.onHand = copyFrom.onHand;
                copyTo.productInventoryType = copyFrom.productInventoryType;
                copyTo.retail = copyFrom.retail;
                copyTo.separator = copyFrom.separator;
                copyTo.showVariantOptions = copyFrom.showVariantOptions;
                copyTo.sku = copyFrom.sku;
                copyTo.wholeSale = copyFrom.wholeSale;
                copyTo.variantDistributorIds = copyFrom.variantDistributorIds;
                copyTo.variantStockLevels = copyFrom.variantStockLevels;
                // didnt copy
                // sortOrder
                // variantAttributes
                // displayName
            }

            scope.FindAndSwapVariantDisplayNameAndAttributes = (copyTo: any, copyFrom: any) => {

                var tempVariantAttributes = _.clone(copyTo.variantAttributes);
                var tempDisplayName = _.clone(copyTo.displayName);
                var tempSortOrder = _.clone(copyTo.sortOrder);

                copyTo.variantAttributes = _.clone(copyFrom.variantAttributes);
                copyTo.displayName = _.clone(copyFrom.displayName);
                copyTo.sortOrder = _.clone(copyFrom.sortOrder);

                copyFrom.variantAttributes = tempVariantAttributes;
                copyFrom.displayName = tempDisplayName;
                copyFrom.sortOrder = tempSortOrder;
            }

            scope.CheckAllowDeleteChip = (rowIndex, chip) => {
                var canDelete = true;

                for (let k = 0; k < scope.context.selectedSection.model.variants.length; k++) {

                    if (
                        (
                            (scope.context.selectedSection.model.variants[k].consolidatedNameFragment1 == chip && rowIndex == 0)
                            || (scope.context.selectedSection.model.variants[k].consolidatedNameFragment2 == chip && rowIndex == 1)
                            || (scope.context.selectedSection.model.variants[k].consolidatedNameFragment3 == chip && rowIndex == 2)
                        )
                        && scope.didVariantExistBefore(scope.context.selectedSection.model.variants[k].id)
                    ) {
                        canDelete = false;
                        break;
                    }
                }

                return canDelete;
            }

            scope.CheckEmptyChip = (rowIndex, chip) => {
                var isEmpty = false;

                if (scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName != null) {
                    for (var j = 0; j < scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName.length; j++) {
                        if (scope.context.selectedSection.model.productVariantAttributes[rowIndex].displayName[j] == '') {
                            isEmpty = true;
                        }
                    }
                }

                return isEmpty;
            }

            scope.getAttributeDisplayName = (number) => {
                if (number == 2166)
                    return "Color";
                else if (number == 2167)
                    return "Height";
                else if (number == 2168)
                    return "Length";
                else if (number == 2169)
                    return "Quality";
                else if (number == 2170)
                    return "Shape";
                else if (number == 2171)
                    return "Size";
                else if (number == 2172)
                    return "Style";
                else if (number == 2173)
                    return "Type";
                else if (number == 2215)
                    return "Weight";
            }

            scope.hideVariantsUntilAtLeastOneAttributeVariantIsCreated = () : boolean => {
                const attributes: Meevo.Model.ProductVariantAttribute[] = scope.context.selectedSection.model.productVariantAttributes;
                if (attributes && attributes.some((attrib) => !attrib.displayName || attrib.displayName.length == 0)) {
                    return true;
                }
                if (scope.originalVariantAtributes.length == 0 && (!attributes || attributes.length == 0)) {
                    // it will only come down here if there are no new attributes yet
                    return true;
                }
                return false;
            }

            scope.startVariantConsolidation = () => {
                // or if entity version != 0
                if (scope.context.selectedSection.model.id != null) {
                    scope.enableVariantConsolidation = true;
                    scope.hideRemainingVariants = true;

                    // always take a new copy of the variants when starting a consolidation in order to fix issues caused by renaming an attribute
                    if (scope.context.selectedSection.model.variants /* && scope.context.selectedSection.model.productVariantAttributes.length != 0 */) {
                        scope.originalVariantsCopy = _.clone(scope.context.selectedSection.model.variants);
                    }
                    else if (scope.oldVariants) {
                        scope.originalVariantsCopy = _.clone(scope.oldVariants);
                    }

                    scope.originalVariantAtributes = _.clone(scope.context.selectedSection.model.productVariantAttributes) || [];
                    scope.originalHasVariantToConsolidate = _.clone(scope.hasVariantToConsolidate);

                    if (scope.originalhasVariants == null) {
                        scope.originalhasVariants = _.clone(scope.hasVariants);
                    }
                    // add new consolidated variable and initiate it to false & change after that variant is consolidated into the new variants
                    for (let i = 0; i < scope.originalVariantsCopy.length; i++) {
                        scope.originalVariantsCopy[i].consolidated = false;
                    }
                }
            }

            // Show/Hide options within the Attribute Type List dropdowns when the selected options change
            scope.processSelectedAttributes = (selectedProductAttribute: any) => {
                var disabledOption = false;
                if (selectedProductAttribute) { // make sure selected text is not ""
                    for (var i = 0; i < scope.context.selectedSection.model.productVariantAttributes.length; i++) {
                        if (scope.context.selectedSection.model.productVariantAttributes[i].variantType == selectedProductAttribute) {
                            disabledOption = true;
                            break;
                        }
                    }
                }
                return disabledOption;
            }

            // Variants object state must be modified when the object is discontinued
            scope.processDiscontinued = (variant: any) => {
                if (variant.isDiscontinued)
                    variant.objectState = Meevo.Model.ObjectStateEnum.Inactive;
                else
                    variant.objectState = Meevo.Model.ObjectStateEnum.Active;
            }

            // Initialize Variants object state
            scope.amIDiscountinued = (variant: any) => {
                if (variant) {
                    variant.isDiscontinued = (variant.objectState == Meevo.Model.ObjectStateEnum.Inactive);
                }
            }

            // The md-chips directive readonly attribute does not handle truthy expressions so I implemented this truthy expression method
            scope.isNotEmptyOrNull = (name: string) => {
                if (name)
                    return true;
                else
                    return false;
            }

            scope.checkForUniqueBarCode = (variant: any) => {
                if (variant.barCode != null &&
                    variant.barCode != "") {
                    scope.context.dataService.customMethodData("api/Product/Variant/Validate/BarCode/", "POST", { BarCode: variant.barCode, variantId: variant.id }).then((data) => {
                        variant.isBarCodeValid = !data.data;
                        if (!variant.isBarCodeValid) {
                            let message = scope.context.$translate.instant("MESSAGE_BARCODE_ALREADY_EXIST", {
                                variantBarCode: (variant.barCode)
                            });
                            scope.context.modalService.alert(message);
                        }
                    });
                }
            }

            scope.getVariantBackupIndex = (variantName: string) => {
                if (scope.context.selectedSection.backup != null) {
                    for (var i = 0; i < scope.context.selectedSection.backup.variants.length; i++) {
                        if (variantName == scope.context.selectedSection.backup.variants[i].displayName)
                            return i;
                    }
                }

                // return a number which is larger then the array size because no match was found
                return 99999;
            }

            scope.checkForUniqueSku = (variant: any) => {

                if (variant.sku != null
                    && variant.sku != "") {

                    scope.context.dataService.customMethodData("api/Product/Variant/Validate/Sku/", "POST", { Sku: variant.sku, variantId: variant.id }).then((data) => {
                        variant.isSkuValid = !data.data;

                        if (!variant.isSkuValid) {
                            let message = scope.context.$translate.instant("MESSAGE_SKU_ALREADY_EXIST", {
                                variantSku: (variant.sku)
                            });
                            scope.context.modalService.alert(message);
                        }
                    });
                }
            }

            scope.isSkuLengthValid = (variant) => {
                if (variant) {
                    variant.isSkuValid = (variant.sku && variant.sku.length <= 30);
                }
            }

            // Check for Valid SKU's across all Variants
            scope.isSkuValid = (sku, id) => {
                // get the index of all variants that match the sku or id
                var variants = scope.context.selectedSection.model.variants.map((m, i) => ({ ...m, index: i })).filter(f => f.id === id || f.sku === sku);
                // get the current variant
                var index = variants.find(f => f.sku === sku && f.id === id).index;

                // we have duplicates, so set the variant to invalid
                if (variants.length > 1) {
                    scope.context.selectedSection.model.variants[index].isSkuValid = false;
                }
                else {
                    // the variant is unique, so set it to valid
                    scope.context.selectedSection.model.variants[index].isSkuValid = true;

                    scope.checkForUniqueSku(scope.context.selectedSection.model.variants[index]);
                }
            }

            scope.isBarCodeLengthValid = (variant) => {
                if (variant) {
                    if (variant.barCode && variant.barCode.length <= 20)
                        variant.isBarCodeValid = true;
                    else
                        variant.isBarCodeValid = false;
                }
            }

            // Check for Valid BarCodes's across all Variants
            scope.isBarCodeValid = (barCode, id) => {

                var valid_state = true;
                var index = 0;
                for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    if (scope.context.selectedSection.model.variants[i].id == id)
                        index = i;
                }
                for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                    if (scope.context.selectedSection.model.variants[i].barCode == barCode && scope.context.selectedSection.model.variants[i].id != id) {
                        valid_state = false;
                        break;
                    }
                }
                scope.context.selectedSection.model.variants[index].isBarCodeValid = valid_state;
                if (valid_state && scope.context.selectedSection.model.variants[index].barCode.length <= 20)
                    scope.context.selectedSection.model.variants[index].isBarCodeValid = true;
                else if (valid_state && scope.context.selectedSection.model.variants[i].barCode.length > 20)
                    scope.context.selectedSection.model.variants[index].isBarCodeValid = false;
                if (valid_state)
                    scope.checkForUniqueBarCode(scope.context.selectedSection.model.variants[index]);

            }

            // Check if form is valid because of the SKU and BarCode unique constraints
            scope.isFormInvalid = () => {

                if (scope.hideRemainingVariants) {
                    return true;
                }

                if (scope.context.selectedSection.model != null) {
                    if (scope.context.selectedSection.model.variants != null) {
                        for (var i = 0; i < scope.context.selectedSection.model.variants.length; i++) {
                            if (scope.context.selectedSection.model.variants[i].isSkuValid == false)
                                return true;
                            else if (scope.context.selectedSection.model.variants[i].isBarCodeValid == false)
                                return true;
                        }
                    }

                    if (scope.hasVariants == Meevo.Model.ObjectStateEnum.Active &&
                        (scope.context.selectedSection.model.productVariantAttributes == null ||
                            scope.context.selectedSection.model.productVariantAttributes.length == 0)) {
                        return true;
                    }
                    else if (scope.hasVariants == Meevo.Model.ObjectStateEnum.Active && scope.context.selectedSection.model.productVariantAttributes != null) {
                        var formIsInvalid = false;
                        for (var i = 0; i < scope.context.selectedSection.model.productVariantAttributes.length; i++) {
                            if (scope.context.selectedSection.model.productVariantAttributes[i].displayName == null || scope.context.selectedSection.model.productVariantAttributes[i].displayName.length == 0) {
                                formIsInvalid = true;
                                break;
                            }
                        }
                        return formIsInvalid;
                    }

                    return false;
                }
                else
                    return true;
            }

            // this function prevents the user from typing a letter into the Variant Type Drop down List in order to select a 2nd duplicate type
            scope.validateVariantTypeChoice = (variantType: any, index: number) => {
                for (var i = 0; i < scope.context.selectedSection.model.productVariantAttributes.length; i++) {
                    if (i != index && scope.context.selectedSection.model.productVariantAttributes[i].variantType == variantType) {
                        scope.context.selectedSection.model.productVariantAttributes[index].variantType = null;
                    }
                }
            }

            scope.createVariatDistributorObject = (distributorId: Guid, variantDistributorId, variantId) => {
                if (variantDistributorId.displayName != null && variantDistributorId.displayName.trim() != '') {
                    variantDistributorId.distributorId = distributorId;
                    variantDistributorId.variantId = variantId;
                }
            }

            scope.productInventoryTypeChanged = (variant: any, originalInventoryType: number) => {
                var onHand = -1;
                var displayInventoryType = 0;

                if (variant.productInventoryType != ProductInventoryTypeEnum.RetailOrShopSupply && variant.productInventoryType != originalInventoryType && !scope.context.isAdding) {
                    if (originalInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply && variant.productInventoryType == ProductInventoryTypeEnum.Retail) {
                        onHand = variant.variantStockLevels.find(x => x.productInventoryType === ProductInventoryTypeEnum.ShopSupply).onHand;
                        displayInventoryType = ProductInventoryTypeEnum.ShopSupply;
                    }
                    else if (originalInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply && variant.productInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                        onHand = variant.variantStockLevels.find(x => x.productInventoryType === ProductInventoryTypeEnum.Retail).onHand;
                        displayInventoryType = ProductInventoryTypeEnum.Retail;
                    }
                    else {
                        onHand = variant.variantStockLevels.find(x => x.productInventoryType === originalInventoryType).onHand;
                        displayInventoryType = originalInventoryType;
                    }

                    onHand = onHand === null ? -1 : onHand;

                    var promise: ng.IPromise<any> = null;
                    if (onHand == 0) {

                        let message = scope.context.$translate.instant("MESSAGE_ATTRIBUTE_ONHANDZERO", {
                            variantname: variant.displayName === "default"
                                ? scope.context.selectedSection.model.displayName
                                : `${scope.context.selectedSection.model.displayName} - ${variant.displayName}`,
                            inventorytype: scope.productInventoryTypes.find(x => x.id === displayInventoryType).displayName
                        });
                        if (variant.productInventoryType === ProductInventoryTypeEnum.Retail) {
                            let canChange = false;
                            promise = scope.canChangeInventoryType(variant.id)
                                .then(() => {
                                    canChange = true;
                                })
                                .finally(() => {
                                    if (!canChange) {
                                        variant.productInventoryType = originalInventoryType;
                                        return false;
                                    }
                                    return scope.context.modalService.info(message);
                                });
                        } else {
                            promise = scope.context.modalService.info(message);
                        }

                    }

                    if (onHand != 0) {

                        let message = scope.context.$translate.instant("MESSAGE_ATTRIBUTE_ONHANDNONZERO", {
                            variantname: variant.displayName === "default" ? scope.context.selectedSection.model.displayName : scope.context.selectedSection.model.displayName + " - " + variant.displayName,
                            inventorytype: scope.productInventoryTypes.find(x => x.id === displayInventoryType).displayName,
                            onhand: onHand
                        });
                        scope.context.modalService.warning(message);
                        variant.productInventoryType = originalInventoryType;
                        return false;
                    }

                    if (scope.context.model.enableProductUsageTracking
                        && (originalInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply || originalInventoryType == ProductInventoryTypeEnum.ShopSupply)
                        && variant.productInventoryType == ProductInventoryTypeEnum.Retail) {
                        if (promise != null) {
                            promise.then(() => { scope.content.modalService.info("MESSAGE_INVENTORY_TYPE_CHANGE_FOR_PRODUCT_USAGE_TRACKING"); });
                        }
                        else {
                            scope.content.modalService.info("MESSAGE_INVENTORY_TYPE_CHANGE_FOR_PRODUCT_USAGE_TRACKING");
                        }
                    }
                }

                scope.enforceNotForSale(variant);

                // If only a single StockLevel record existed in the DB then create another
                if (variant.variantStockLevels.length == 1) {
                    if (variant.variantStockLevels[0].productInventoryType == ProductInventoryTypeEnum.Retail
                        && (variant.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply
                            || variant.productInventoryType == ProductInventoryTypeEnum.ShopSupply)) {
                        variant.variantStockLevels.push({
                            variantId: variant.id,
                            productPackageType: ProductPackageTypeEnum.Each,
                            productInventoryType: ProductInventoryTypeEnum.ShopSupply,
                            multiplesOf: 1,
                            modelQuantity: 0,
                            orderPoint: 0,
                            onHand: 0,
                            wasChanged: false
                        });
                    }
                    else if (variant.variantStockLevels[0].productInventoryType == ProductInventoryTypeEnum.ShopSupply
                        && (variant.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply
                            || variant.productInventoryType == ProductInventoryTypeEnum.Retail)) {
                        variant.variantStockLevels.push({
                            variantId: variant.id,
                            productPackageType: ProductPackageTypeEnum.Each,
                            productInventoryType: ProductInventoryTypeEnum.Retail,
                            multiplesOf: 1,
                            modelQuantity: 0,
                            orderPoint: 0,
                            onHand: 0,
                            wasChanged: false
                        });
                    }
                }

                scope.determineWhichStockLevelRecordsToDisplay(variant);
            }

            scope.canChangeInventoryType = (id: string): boolean => {
                return scope.context.dataService.customMethodData(`api/product/${id}/Usage/Check`, 'GET', null).then((data) => {
                    if (data.data && data.data.variantUsageChecking.some(x => x.hasUsage)) {
                        const message = scope.context.$translate.instant("MESSAGE_INVENTORY_TYPE_CHANGE_FOR_PRODUCT_USAGE_TRACKING_CONFIRM");
                        return scope.context.modalService.yellowConfirm(message).then(() => true);
                    }
                    return false;
                });
            };

            scope.stockLevelWasChanged = (stockLevel, packageTypeOrMultiplesOfWasChanged) => {
                stockLevel.wasChanged = true;
                if (!scope.context.identityService.inCentralOfficeMode() && !scope.context.identityService.checkCentralOfficeLocationId(scope.context.asLocationId) && scope.context.identityService.checkCentralOfficeLocationId(scope.context.selectedSection.model.homeLocationId)) {
                    if (packageTypeOrMultiplesOfWasChanged) {
                        stockLevel.showProductPackageTypeAndMultiplesOfRevertIndicator = true;
                    }
                    else if (!packageTypeOrMultiplesOfWasChanged) {
                        stockLevel.showModelQuantityAndOrderPointRevertIndicator = true;
                    }
                }
                stockLevel.modelQuantity = parseInt(stockLevel.modelQuantity);
                if (stockLevel.orderPoint > stockLevel.modelQuantity) {
                    stockLevel.orderPoint = stockLevel.modelQuantity;
                }
            }

            scope.determineWhichStockLevelRecordsToDisplay = (variant: any) => {
                //Ensure only the stock levels that match the selected inventory type are shown
                for (var i = 0; i < variant.variantStockLevels.length; i++) {
                    if (variant.productInventoryType == variant.variantStockLevels[i].productInventoryType || variant.productInventoryType == ProductInventoryTypeEnum.RetailOrShopSupply) {
                        variant.variantStockLevels[i].isDisplayed = true;
                    }
                    else {
                        variant.variantStockLevels[i].isDisplayed = false;
                    }
                }
            }

            scope.enforceNotForSale = (variant: any) => {
                if (variant.productInventoryType === Meevo.Model.ProductInventoryTypeEnum.ShopSupply) {
                    variant.notForSale = true;
                }
            }

            scope.determineIfRevertIndicatorIsShown = (variant: any) => {
                if (variant.variantStockLevels != null && !scope.context.identityService.inCentralOfficeMode() && !scope.context.identityService.checkCentralOfficeLocationId(scope.context.asLocationId) && scope.context.identityService.checkCentralOfficeLocationId(scope.context.selectedSection.model.homeLocationId)) {
                    for (var i = 0; i < variant.variantStockLevels.length; i++) {
                        var stockLevel = variant.variantStockLevels[i];
                        // When there is a difference in the Tenant Level Value and the Location Level Value then allow the value to be reverted to tenant level record values
                        if (((stockLevel.productPackageType_L != null && stockLevel.productPackageType_L != 0) && ((stockLevel.productPackageType != stockLevel.productPackageType_T && stockLevel.productPackageType_T != 0 && stockLevel.productPackageType_T != null)))
                            || (stockLevel.multiplesOf_L != null && ((stockLevel.multiplesOf != stockLevel.multiplesOf_T && stockLevel.multiplesOf_T != 0 && stockLevel.multiplesOf_T != null)))) {
                            stockLevel.showProductPackageTypeAndMultiplesOfRevertIndicator = true;
                        }
                        // When there is a difference in the Tenant Level Value and the Location Level Value then allow the value to be reverted to tenant level record values
                        if ((stockLevel.modelQuantity_L != null && ((stockLevel.modelQuantity != stockLevel.modelQuantity_T && stockLevel.modelQuantity_T != null)))
                            || (stockLevel.orderPoint_L != null && ((stockLevel.orderPoint != stockLevel.orderPoint_T && stockLevel.orderPoint_T != null)))) {
                            stockLevel.showModelQuantityAndOrderPointRevertIndicator = true;
                        }
                    }
                }

            }

            scope.getDecimalPrecision = (variantStockLevel: any): boolean => {
                return (!Number.isInteger(variantStockLevel.onHand)
                    || (scope.tenantEnableProductUsageTracking
                        && variantStockLevel.enableProductUsageTracking
                        && variantStockLevel.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount))
                    ? scope.decimalPrecision
                    : null;
            }

            scope.needToOrder = (stockLevel: any): boolean => {
                return ((stockLevel.onHand <= stockLevel.orderPoint && stockLevel.modelQuantity > stockLevel.orderPoint)
                    || (stockLevel.onHand < stockLevel.orderPoint && stockLevel.modelQuantity == stockLevel.orderPoint));
            }

            // Controls which variant rows are visible in the consolidation UI
            // Called by ng-hide in productVariantTemplate.html for each variant row
            scope.hideVariantConsolidation = (index: number) => {
                const variants = scope.context.selectedSection.model.variants;
                const variant = variants && variants[index];
                
                // Hide unmarked variants (duplicates created when adding new attributes)
                // Uses alreadyConsolidated flag instead of array position comparison (bug 113798 fix)
                const isUnmarkedDuplicateVariant = scope.hideRemainingVariants 
                    && variant 
                    && !variant.alreadyConsolidated;
                
                return scope.hasVariantToConsolidate
                    && scope.enableVariantConsolidation
                    && (scope.hideVariantsUntilAtLeastOneAttributeVariantIsCreated() || isUnmarkedDuplicateVariant);
            }

            scope.diableSingleMultiVariantToggle = () => {
                return scope.context.isReadonly ||
                    !scope.context.isAccessible ||
                    (scope.hasVariants == Meevo.Model.ObjectStateEnum.Active && scope.context.selectedSection.model.id);
            }

            /*
            scope.CalculateMarkupValue = (markUp: number, maxDecimalPlace: number) => {
                // check decimal precision constraint
                var value = (markUp * 100).toFixed(maxDecimalPlace).toString();
                if (value.indexOf("%") == -1 && value.indexOf(".") != -1 && value.indexOf(".") < value.length && value.substring(value.indexOf("."), value.length).length > maxDecimalPlace + 1) {
                    return value.substring(0, value.indexOf(".")) + value.substring(value.indexOf("."), value.indexOf(".") + (maxDecimalPlace + 1)) + "%";
                }
                else if (value.indexOf("%") != -1 && value.indexOf(".") != -1 && value.indexOf(".") < value.length && value.substring(value.indexOf("."), value.length-1).length > maxDecimalPlace + 1) {
                    return value.substring(0, value.indexOf(".")) + value.substring(value.indexOf("."), value.indexOf(".") + (maxDecimalPlace + 1)) + "%";
                }

                if (markUp != undefined && markUp.toString().indexOf(".") == -1 )
                {
                    markUp = Number((markUp).toFixed(maxDecimalPlace).toString());
                }

                return value;
            }*/

            //this function fires off after the cancel button is pressed
            scope.$watch(() => scope.disablevariantconsolidation, (newVal: any, oldVal: any) => {
                if (newVal == true) {
                    if (scope.originalhasVariants == 2026) {
                        scope.hasVariants = 2026;
                    }
                    else if (scope.originalhasVariants == 2027) {
                        scope.hasVariants = 2027;
                    }
                    scope.oldVariants = null;
                    scope.originalVariantsCopy = null;
                    scope.latestConsolidatedVariantsCopy = null;
                    scope.enableVariantConsolidation = false;
                    scope.renamingChip = false;
                    scope.chipRowBeingRenamed = null;
                    scope.chipBeingRenamed = null;
                    scope.deletedVariantCombinations = [];
                    if (scope.context.selectedSection.model.variants.length < getTotalCombination()) {
                        scope.createAllVariantCombinations(true);
                    }

                }
            });
            this.$timeout(() => {
                scope.InitializeData();
            }, 1);
        }];

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout: ng.ITimeoutService, $translate: angular.translate.ITranslateService) => {
                return new ProductVariant($timeout, $translate);
            };
            directive.$inject = ["$timeout", "$translate"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("productVariant", ProductVariant.factory());
}
